import React, {useEffect, useState} from 'react'
import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
  useDismiss,
  useInteractions,
} from '@floating-ui/react'
import {Tooltip} from 'react-tooltip'
import {getCommentByPiece} from '../../../../../components/requests'
import ButtonActionPopper from '../ButtonActionPopper'
import CommentSectionPropper from './CommentSectionPropper'

export default function ActionPopper(props) {
  const {
    piece,
    index,
    handleWriteComment,
    handlePanier,
    showCommentInput,
    showCommentSection,
    setShowCommentSection,
    fromSuggestionPage,
    pieceSuggestionComms,
    handleChangeStatutPropo,
  } = props

  const [open, setOpen] = useState(false)
  const {refs, floatingStyles, context} = useFloating({
    open,
    onOpenChange: setOpen,
    placement: 'bottom-end',
    middleware: [offset(6), flip(), shift()],
    whileElementsMounted: autoUpdate,
  })

  const dismiss = useDismiss(context)

  const {getReferenceProps, getFloatingProps} = useInteractions([dismiss])
  const [commentaires, setCommentaires] = useState([])
  const [commentaireLoader, setCommentaireLoader] = useState<boolean>(false)

  // Ouverture & Fermeture Bouton "Autre actions"
  const handleMoreActionsOpening = () => {
    if (fromSuggestionPage) {
      setOpen((prev) => !prev)

      setShowCommentSection(true)
    } else {
      setOpen((prev) => !prev)
      setShowCommentSection(false)
    }
  }

  // Commentaire via chaque pièce dans la page suggestion
  useEffect(() => {
    if (pieceSuggestionComms && pieceSuggestionComms.length > 0) {
      setCommentaires(pieceSuggestionComms)
    }
  }, [pieceSuggestionComms])

  return (
    <>
      {/*Bouton d'ouverture du popper*/}
      <button
        ref={refs.setReference}
        {...getReferenceProps()}
        onClick={() => handleMoreActionsOpening()}
        className='btn btn-icon btn-bg-light btn-sm'
        data-tooltip-id='panier-actions'
        data-tooltip-content='Voir message'
        data-tooltip-place='left'
      >
        {fromSuggestionPage ? (
          <i className='ki-duotone ki-message-text fs-2'>
            <span className='path1'></span>
            <span className='path2'></span>
            <span className='path3'></span>
          </i>
        ) : (
          <i className='ki-duotone ki-dots-vertical fs-3x'>
            <span className='path1'></span>
            <span className='path2'></span>
            <span className='path3'></span>
          </i>
        )}
      </button>

      {/*Contenu du popper*/}
      {open && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
          className='shadow bg-white p-2 rounded d-flex flex-column gap-1 align-items-center z-index-1'
        >
          {/*Boutons dans Autres actions*/}
          <ButtonActionPopper
            showCommentSection={showCommentSection}
            piece={piece}
            showCommentInput={showCommentInput}
            setShowCommentSection={setShowCommentSection}
            setCommentaireLoader={setCommentaireLoader}
            setCommentaires={setCommentaires}
            handleWriteComment={handleWriteComment}
            handlePanier={handlePanier}
            index={index}
            fromSuggestionPage={fromSuggestionPage}
            setOpen={setOpen}
            handleChangeStatutPropo={handleChangeStatutPropo}
          />
          {/*Liste des commentaires*/}
          <CommentSectionPropper
            showCommentSection={showCommentSection}
            commentaireLoader={fromSuggestionPage == true ? false : commentaireLoader}
            commentaires={commentaires}
            fromSuggestionPage={fromSuggestionPage}
          />
        </div>
      )}
      <Tooltip id='panier-actions' style={{backgroundColor: 'black', color: 'white'}} />
    </>
  )
}